/* ScrubToss — interaction layer. No framework, no dependencies. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Bundle selector -> product form ---- */
  document.querySelectorAll('[data-bundle-form]').forEach(function (form) {
    var idField = form.querySelector('[data-variant-id]');
    form.querySelectorAll('input[name="bundle"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (idField) idField.value = input.value;
        /* the sticky bar's figure is written by refresh() so it always shows
           the same total as the main button, add-ons included */

        /* Jump the gallery to the media attached to the chosen variant.
           Variants without their own media leave the gallery where it is. */
        var mediaId = input.dataset.variantMediaId;
        var gal = document.querySelector('[data-gallery]');
        if (mediaId && gal && gal.__showMedia) gal.__showMedia(mediaId);
      });
    });
  });

  /* ---- FAQ: one open at a time ---- */
  document.querySelectorAll('[data-faq]').forEach(function (group) {
    var items = group.querySelectorAll('details');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (o) { if (o !== item) o.open = false; });
      });
    });
  });

  /* ---- Reveal fallback for engines without animation-timeline ---- */
  var hasScrollTimeline = CSS.supports && CSS.supports('animation-timeline: view()');
  if (!hasScrollTimeline && !reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    document.querySelectorAll('.reveal, .reveal-up, .stagger').forEach(function (el) { io.observe(el); });
  }

  /* ---- Count-up stats ---- */
  var counters = document.querySelectorAll('[data-count-to]');
  if (counters.length) {
    if (reduced || !('IntersectionObserver' in window)) {
      counters.forEach(function (el) { el.textContent = el.dataset.countTo + (el.dataset.suffix || ''); });
    } else {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target, target = parseInt(el.dataset.countTo, 10) || 0, suffix = el.dataset.suffix || '';
          cio.unobserve(el);
          if (target === 0) { el.textContent = '0' + suffix; return; }
          var start = performance.now(), dur = 1100;
          (function tick(now) {
            var p = Math.min((now - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased) + suffix;
            if (p < 1) requestAnimationFrame(tick);
          })(start);
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { cio.observe(el); });
    }
  }

  /* ---- Sticky add-to-cart ---- */
  var bar = document.querySelector('.sticky-atc');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(anchor);

    bar.querySelector('[data-atc-submit]')?.addEventListener('click', function () {
      document.querySelector('[data-bundle-form]')?.requestSubmit();
    });
  }
  /* ---- Video wall: only play what is on screen ---- */
  var wall = document.querySelector('[data-video-wall]');
  if (wall && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'metadata';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { root: wall, threshold: 0.35 });
    wall.querySelectorAll('video').forEach(function (v) {
      v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('controls');
      vio.observe(v);
    });
  }

  /* ---- Product gallery: image and video slides ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('.gallery__slide');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    if (!slides.length) return;

    function show(id) {
      slides.forEach(function (s) {
        var on = s.dataset.mediaId === id;
        s.hidden = !on;
        var v = s.querySelector('video');
        if (!v) return;
        /* a hidden video keeps buffering and playing audio-less frames for
           nothing, so it is paused and rewound when it leaves the stage */
        if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
      thumbs.forEach(function (t) {
        if (t.dataset.mediaId === id) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.mediaId); });
    });
    g.__showMedia = show;
  });
  /* ---- Reviews: reveal the rest ---- */
  document.querySelectorAll('[data-reviews-more]').forEach(function (btn) {
    var grid = document.querySelector('[data-reviews-grid]');
    if (!grid) return;
    btn.addEventListener('click', function () {
      var hidden = grid.querySelectorAll('.rv__card--hidden');
      if (hidden.length) {
        hidden.forEach(function (c) { c.classList.remove('rv__card--hidden'); });
        btn.textContent = btn.dataset.labelLess;
        btn.dataset.expanded = 'true';
      } else if (btn.dataset.expanded === 'true') {
        var cards = grid.querySelectorAll('.rv__card');
        cards.forEach(function (c, i) { if (i >= 6) c.classList.add('rv__card--hidden'); });
        btn.textContent = btn.dataset.labelMore;
        btn.dataset.expanded = 'false';
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- Cart: quantity stepper ----
     Typing fires on change; the buttons debounce so holding + does not
     submit the form on every click. */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    var timer;
    function commit() {
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 450);
    }
    form.querySelectorAll('[data-qty]').forEach(function (box) {
      var input = box.querySelector('[data-cart-qty]');
      if (!input) return;
      box.querySelector('[data-qty-down]')?.addEventListener('click', function () {
        input.value = Math.max(0, (Number(input.value) || 0) - 1);
        commit();
      });
      box.querySelector('[data-qty-up]')?.addEventListener('click', function () {
        input.value = (Number(input.value) || 0) + 1;
        commit();
      });
    });
    form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.value === '' || Number(input.value) < 0) input.value = 0;
        clearTimeout(timer);
        form.submit();
      });
    });
  });

  /* ---- Cross-sell: add without leaving the page ---- */
  document.querySelectorAll('[data-xs-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;              // no fetch: let it post normally
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }]
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.textContent = btn.dataset.labelDone;
          btn.dataset.state = 'done';
          // on the cart page the totals must reflect the addition
          if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
          setTimeout(function () {
            btn.textContent = btn.dataset.labelIdle;
            btn.removeAttribute('data-state');
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () { form.submit(); });   // fall back to the real post
    });
  });

  /* ---- Cart cross-sell: adds ONLY that product, then refreshes totals ---- */
  document.querySelectorAll('[data-xs-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.dataset.state = 'busy';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.xsVariant), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          btn.disabled = false;
          btn.removeAttribute('data-state');
          btn.textContent = btn.dataset.labelIdle;
        });
    });
  });

  /* ---- Product form: running total + multi-item add ---- */
  (function () {
    var form = document.querySelector('[data-bundle-form]');
    if (!form) return;
    var atc = form.querySelector('[data-atc]');
    var totalEl = form.querySelector('[data-atc-total]');
    var idField = form.querySelector('[data-variant-id]');
    if (!atc) return;

    /* Shopify's money_format is a template like "${{amount}}". Rendering the
       total client-side means the button can never disagree with the cart. */
    var fmt = atc.dataset.moneyFormat || '${{amount}}';
    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amount = parts.join('.');
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
    }

    function baseCents() {
      var checked = form.querySelector('input[name="bundle"]:checked');
      if (checked && checked.dataset.priceCents) return Number(checked.dataset.priceCents);
      return Number(atc.dataset.baseCents || 0);
    }

    function addons() {
      return [].slice.call(form.querySelectorAll('[data-addon-check]:checked'));
    }

    function refresh() {
      var sum = baseCents();
      addons().forEach(function (c) { sum += Number(c.dataset.addonCents || 0); });
      var text = money(sum);
      if (totalEl) totalEl.textContent = text;
      document.querySelectorAll('[data-selected-price]').forEach(function (el) {
        el.textContent = text;
      });
    }

    if (totalEl && !atc.dataset.baseCents) {
      var first = form.querySelector('input[name="bundle"]:checked');
      atc.dataset.baseCents = first ? (first.dataset.priceCents || 0) : 0;
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-addon-check]') || e.target.matches('input[name="bundle"]')) refresh();
    });
    refresh();

    form.addEventListener('submit', function (e) {
      var extras = addons();
      if (!extras.length || !window.fetch) return;   // nothing extra: let Shopify handle it
      e.preventDefault();
      var items = [{ id: Number(idField.value), quantity: 1 }];
      extras.forEach(function (c) { items.push({ id: Number(c.dataset.addonVariant), quantity: 1 }); });
      atc.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { atc.disabled = false; form.submit(); });
    });
  })();

  /* ---- Header cart count stays in step with AJAX adds ---- */
  window.stRefreshCartCount = function () {
    var el = document.querySelector('[data-cart-count]');
    if (!el || !window.fetch) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        el.textContent = c.item_count;
        el.classList.toggle('cartlink__count--empty', c.item_count === 0);
      })
      .catch(function () {});
  };

})();
